<arcgis-map
	[zoom]="currentZoom"
	[basemap]="basemap"
	[popupEnabled]="popupEnabled"
	(arcgisViewReadyChange)="arcgisViewReadyChange($event)"
	(arcgisViewPointerDown)="arcgisViewPointerDown($event)"
	
	#arcgismap
>
</arcgis-map>